import { HeroIcon } from '@components/HeroIcon'
import { View, Text, XStack } from 'tamagui'
import { Button } from '@components/Button'

export function ActivityHeader() {
  return (
    <XStack justifyContent="space-between">
      <Button link p={0}>
        <View
          flexDirection="row"
          alignItems="center"
          gap="$spacing-inset-quarck"
        >
          <View p="$spacing-inset-xs">
            <HeroIcon
              icon={['fas', 'angle-left']}
              size={16}
              color="$neutral-600"
            />
          </View>
          <Text
            ff="$mulishSemiBold"
            fontSize="$font-size-xs"
            color="$neutral-600"
          >
            Anterior
          </Text>
        </View>
      </Button>
      <Button link p={0}>
        <View
          flexDirection="row"
          alignItems="center"
          gap="$spacing-inset-quarck"
        >
          <Text
            ff="$mulishSemiBold"
            fontSize="$font-size-xs"
            color="$neutral-600"
          >
            Próximo
          </Text>
          <View p="$spacing-inset-xs">
            <HeroIcon
              icon={['fas', 'angle-right']}
              size={16}
              color="$neutral-600"
            />
          </View>
        </View>
      </Button>
    </XStack>
  )
}
